import React, { Component } from 'react';
// import classes from './Layout.css';
import classes from './Layout.css';
import Navbar from '../../components/Navigation/Navbar/Navbar.jsx';
import Drawer from '../../components/Navigation/Drawer/Drawer.jsx';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actionCreators from '../../store/actions/index';



class Layout extends Component {

  mouseTracker = (e) => {
    if (this.props.menuMouseTracker) {
      let menuBoundingBox = document.querySelector('.userMenu').getBoundingClientRect();
      let menuLeft = menuBoundingBox.left;
      let menuRight = menuBoundingBox.right;
      let menuBottom = menuBoundingBox.bottom;
      if (e.clientX < menuLeft || e.clientX > menuRight || e.clientY > menuBottom) {
        this.props.ToggleUserMenu('close');
      }
    }
  }

  render() {
    let mouseTracker = null;
    if (this.props.menuMouseTracker) {
      mouseTracker = (e) => { this.mouseTracker(e) }
    }

    return (<div onMouseMove={mouseTracker}>
      <Navbar
        toggleDrawer={() => { this.props.ToggleDrawer(null) }}
        openState={this.props.drawerOpen}
        isAuth={this.props.token !== null}
        closeDrawer={() => { this.props.ToggleDrawer('close') }} />
      <Drawer openState={this.props.drawerOpen} />
      <main className={classes.Content}>
        {this.props.children}
      </main>
    </div>
    )
  };
}

const mapStateToProps = (state) => {
  return {
    drawerOpen: state.global.drawerOpen,
    menuMouseTracker: state.global.menuMouseTracker,
    token: state.auth.token
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    ToggleDrawer: (toggleAction) => dispatch(actionCreators.toggleDrawer(toggleAction)),
    ToggleUserMenu: (toggleAction) => dispatch(actionCreators.toggleUserMenu(toggleAction))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Layout));


// WEBPACK FOOTER //
// ./src/hoc/Layout/Layout.jsx